import type { RouteRecordRaw } from 'vue-router';

// Single-page Configure surface (post 2026-05-14 design-canonical
// integration). The /auctions/new/configure create-flow path is gone —
// auction creation is the CreateAuctionDrawer on the /auctions index;
// landing on /auctions/:id/configure then refines.
export const routes: RouteRecordRaw[] = [
  {
    path: '/auctions/:id/configure',
    name: 'configure',
    component: () => import('./pages/ConfigurePage.vue'),
    meta: {
      requiresAdminAuth: true,
      requiredRole: 'admin',
      // Reachable in every status (lifecycle-stable nav): the page's own
      // read-only handling covers a closed auction rather than a route gate,
      // because metadata stays editable after close (GT1-428).
      lifecycle: ['draft', 'published', 'open', 'closed'],
    },
  },
];
